import { possiblyMomentToDate, resolveDateFromFormats } from '@gef-ui/date-fns-utils';
import { isValid } from 'date-fns';
/**
 * Validate date
 *
 * @documented
 * @category Date
 * @import import { isDate } from '@gef-ui/validations/validationFunctions/date'
 * @param {Object} input
 * @param {Date} [input.after]
 * @param {Date} [input.before]
 * @returns {String} errMessage
 *
 */ function isDate({ after, before, incorrectDateMessageKey = 'incorrectDateInserted', incorrectMonthMessageKey = 'incorrectMonthInserted', incorrectYearMessageKey = 'incorrectYearInserted', incorrectDateFormatMessageKey = 'incorrectDateFormat', dateNotBeforeMessageKey = 'dateNotBefore', dateNotAfterMessageKey = 'dateNotAfter' }) {
    return ({ fieldValue })=>{
        if (!fieldValue) {
            return undefined;
        }
        const matches = /^(\d{2})[.\/](\d{2})[.\/](\d{4})$/.exec(fieldValue);
        if (matches !== null) {
            const d = parseInt(matches[1], 10);
            const m = parseInt(matches[2], 10) - 1;
            const y = parseInt(matches[3], 10);
            const composedDate = new Date(y, m, d);
            if (composedDate.getDate() !== d) {
                return incorrectDateMessageKey;
            } else if (composedDate.getMonth() !== m) {
                return incorrectMonthMessageKey;
            } else if (composedDate.getFullYear() !== y) {
                return incorrectYearMessageKey;
            }
            const beforeFinal = possiblyMomentToDate(before);
            const afterFinal = possiblyMomentToDate(after);
            if (beforeFinal && composedDate.getTime() >= beforeFinal.getTime()) {
                return dateNotBeforeMessageKey;
            } else if (afterFinal && composedDate.getTime() <= afterFinal.getTime()) {
                return dateNotAfterMessageKey;
            }
        } else {
            return incorrectDateFormatMessageKey;
        }
        return undefined;
    };
}
/**
 * Validate moment date
 *
 * @documented
 * @category Date
 * @import import { isDateMoment } from '@gef-ui/validations/validationFunctions/date'
 * @param {Object} input
 * @param {Date} [input.after]
 * @param {Date} [input.before]
 * @param {String[]} [input.dateFormats=['DD.MM.YYYY']]
 * @returns {String} errMessage
 *
 */ const isDateMoment = ({ after, before, dateFormats = [
    'DD.MM.YYYY'
], incorrectDateFormatMessageKey = 'incorrectDateFormat', dateNotBeforeMessageKey = 'dateNotBefore', dateNotAfterMessageKey = 'dateNotAfter' })=>({ fieldValue })=>{
        let result = false;
        if (!fieldValue) {
            return result;
        }
        const date = resolveDateFromFormats(dateFormats, fieldValue);
        if (date && isValid(date)) {
            const beforeFinal = possiblyMomentToDate(before);
            const afterFinal = possiblyMomentToDate(after);
            if (beforeFinal && date.getTime() >= beforeFinal.getTime()) {
                result = dateNotBeforeMessageKey;
            } else if (afterFinal && date.getTime() <= afterFinal.getTime()) {
                result = dateNotAfterMessageKey;
            }
        } else {
            result = incorrectDateFormatMessageKey;
        }
        return result;
    };
export default {
    isDateMoment,
    isDate
};
